import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vu-audio-es',
  templateUrl: 'audio-es.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VUOnboardingAudioESComponent { }
